import React from 'react';
import Logo from "../../elements/logo/Logo";
import Nav from './Nav';
import { FiX } from "react-icons/fi";
import Darkmode from './Darkmode';

const MobileMenu = ({show, onClose}) => {
    // Move to useEffect to run after component mounts
    React.useEffect(() => {
        var elements = document.querySelectorAll('.popup-mobile-menu .has-droupdown > a');
        var elementsTwo = document.querySelectorAll('.popup-mobile-menu .with-megamenu > a');
        
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    const submenu = this.parentElement.querySelector('.submenu');
                    if (submenu) {
                        submenu.classList.toggle("active");
                        this.classList.toggle("open");
                    }
                }
            }
        }

        for(var i in elementsTwo) {
            if(elementsTwo.hasOwnProperty(i)) {
                elementsTwo[i].onclick = function() {
                    const megamenu = this.parentElement.querySelector('.rn-megamenu');
                    if (megamenu) {
                        megamenu.classList.toggle("active");
                        this.classList.toggle("open");
                    }
                }
            }
        }
    }, []);
    return (
        <div className={`popup-mobile-menu ${show ? "active": ""}`} role="navigation" aria-label="Mobile navigation">
            <div className="inner">
                <div className="header-top">
                    <Logo 
                        image={`${process.env.PUBLIC_URL}/images/logo/WhatsOnAgencyWhite.png`}
                        image2={`${process.env.PUBLIC_URL}/images/logo/WhatsOn_AgencyRed.png`}
                    />
                    <div className="close-menu">
                        <span className="close-button" role="button" tabIndex={0} aria-label="Close mobile menu" onClick={onClose} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClose(); }}><FiX /></span>
                    </div>
                </div>
                <div className="mobile-menu-actions">
                    <Darkmode />
                    <a
                        className="btn-default btn-small round btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="/special-offer"
                    >
                        GET A Quote
                    </a>
                    <a
                        className="btn-default btn-small round btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="/free-digital-audit"
                    >
                        DIGITAL AUDIT
                    </a>
                </div>
                <Nav />
            </div>
        </div>
    )
}
export default MobileMenu;